import state from './state'
import mutations from './mutations'
import actions from './actions'

const getters = {
  init: state => state.init
}

const auth = {
  state,
  mutations,
  actions,
  getters
}

export default auth



// WEBPACK FOOTER //
// ./src/store/auth/index.js